import { queryOptions } from '@tanstack/react-query';
import { fetchUserJourney } from '@wundo/client/userJourneys.ts';

/** One journey, as both its route loader and the page ask for it. */
export function userJourneyQuery(userId: string, journeyId: string) {
  return queryOptions({
    queryKey: ['userJourney', userId, journeyId],
    queryFn: () => fetchUserJourney(userId, journeyId),
  });
}
